import React from 'react';
import './panel.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Panel = props => {
    const {
        children,
        color,
        fullHeight,
        currentPage,
        flexDirection,
        withSpacing,
        withPadding,
        verticalAlign,
    } = props;

    const label = `${currentPage} Panel`;

    const panelClasses = classNames({
        panel: true,
        'panel--purple': color === 'purple',
        'panel--less-opacity-white': color === 'less-opacity-white',
        'panel--full-height': fullHeight === true,
        'panel--flex-direction-column': flexDirection === 'column',
        'panel--spacing': withSpacing === true,
        'panel--padding-false': withPadding === false,
        'panel--vertical-align-center': verticalAlign === 'middle',
    });

    return (
        <main aria-label={label} className={panelClasses}>
            {children}
        </main>
    );
};

Panel.defaultProps = {
    color: 'white',
    fullHeight: false,
    currentPage: '',
    flexDirection: 'row',
    withSpacing: false,
    withPadding: true,
    verticalAlign: 'top',
};

Panel.propTypes = {
    color: PropTypes.oneOf(['white', 'purple', 'less-opacity-white']),
    fullHeight: PropTypes.bool,
    currentPage: PropTypes.string.isRequired,
    flexDirection: PropTypes.string,
    withSpacing: PropTypes.bool,
    withPadding: PropTypes.bool,
    verticalAlign: PropTypes.oneOf(['middle', 'top']),
};

export { Panel };
